import { Container, Row, Col } from "react-bootstrap";
import { MapPin, Phone, Mail, Clock, Navigation } from 'lucide-react';

function Mapa() {
    const ubicacionInfo = {
        direccion: "Av. Villazon Km 5, Cochabamba, Bolivia",
        telefono: "454 4825 | 454 4712 | 75986800",
        email: "atencionalcliente@salcedoimport.com",
        horario: {
            semana: "Lunes a Viernes: 8:00 - 12:00 | 14:00 - 18:00",
            sabado: "Sábados: 8:00 - 12:00"
        }
    };

    return (
        <section className="mapa-section">
            {/* Fondo decorativo */}
            <div className="mapa-background">
                <div className="mapa-shape mapa-shape-1"></div>
                <div className="mapa-shape mapa-shape-2"></div>
                <div className="mapa-dots-pattern"></div>
            </div>

            <Container className="mapa-container">
                {/* Header */}
                <div className="mapa-header text-center">
                    <div className="mapa-badge">
                        <MapPin size={20} />
                        <span>Ubicación</span>
                    </div>
                    <h2 className="mapa-title">
                        Encuéntranos en <span className="text-highlight-mapa">Cochabamba</span>
                    </h2>
                    <p className="mapa-subtitle">
                        Te esperamos en nuestras oficinas y showroom
                    </p>
                    <div className="title-divider-mapa"></div>
                </div>

                <Row className="g-4">
                    {/* Columna del Mapa */}
                    <Col lg={8}>
                        <div className="mapa-wrapper">
                            {/* Badge de ubicación flotante */}
                            {/* <div className="mapa-floating-badge">
                                <MapPin size={24} />
                                <span>Nuestra Ubicación</span>
                            </div> */}

                            <iframe
                                title="Mapa de ubicación"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.497995118576!2d-66.10221942391607!3d-17.387872764209412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x93e371003ddc91cf%3A0x9c73565bfed7b8a8!2sTruper%20importadora%20Salcedo!5e0!3m2!1ses!2sbo!4v1758223178111!5m2!1ses!2sbo"
                                width="100%"
                                height="100%"
                                className="mapa-iframe"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />

                            {/* Botón de direcciones */}
                            <a 
                                href="https://www.google.com/maps/dir//Truper+importadora+Salcedo/@-17.387872764209412,-66.10221942391607,17z"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-direcciones"
                            >
                                <Navigation size={20} />
                                Cómo Llegar
                            </a>
                        </div>
                    </Col>

                    {/* Columna de Información */}
                    <Col lg={4}>
                        <div className="ubicacion-info-section">
                            {/* Card de Dirección */}
                            <div className="ubicacion-card direccion-card">
                                <div className="card-icon-wrapper">
                                    <MapPin size={32} />
                                </div>
                                <h3 className="card-title">Dirección</h3>
                                <p className="card-text">{ubicacionInfo.direccion}</p>
                            </div>

                            {/* Card de Contacto */}
                            <div className="ubicacion-card contacto-card">
                                <div className="info-item">
                                    <div className="info-icon">
                                        <Phone size={20} />
                                    </div>
                                    <div className="info-content">
                                        <h4>Teléfono</h4>
                                        <p>{ubicacionInfo.telefono}</p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <div className="info-icon">
                                        <Mail size={20} />
                                    </div>
                                    <div className="info-content">
                                        <h4>Email</h4>
                                        <p>{ubicacionInfo.email}</p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <div className="info-icon">
                                        <Clock size={20} />
                                    </div>
                                    <div className="info-content">
                                        <h4>Horarios</h4>
                                        <p>{ubicacionInfo.horario.semana}</p>
                                        <p>{ubicacionInfo.horario.sabado}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Puntos de Referencia */}
                            {/* <div className="ubicacion-card referencias-card">
                                <h4 className="referencias-title">Puntos de Referencia</h4>
                                <div className="referencias-list">
                                    {puntosReferencia.map((punto, index) => (
                                        <div 
                                            key={index} 
                                            className="referencia-item"
                                            style={{ animationDelay: `${index * 0.1}s` }}
                                        >
                                            <div className="referencia-icon">
                                                {punto.icon}
                                            </div>
                                            <span>{punto.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div> */}

                            {/* CTA */}
                            {/* <div className="ubicacion-cta">
                                <h4 className="cta-title-mapa">¿Necesitas más información?</h4>
                                <a href="/contacto" className="btn-mapa-cta">
                                    Contáctanos
                                </a>
                            </div> */}
                        </div>
                    </Col>
                </Row>

                {/* Sección de Características de Ubicación */}
                {/* <div className="ubicacion-features">
                    <Row className="g-4">
                        <Col md={4}>
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <Car size={32} />
                                </div>
                                <h4 className="feature-title">Estacionamiento</h4>
                                <p className="feature-description">
                                    Amplio espacio de estacionamiento para tu comodidad
                                </p>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <Building2 size={32} />
                                </div>
                                <h4 className="feature-title">Showroom</h4>
                                <p className="feature-description">
                                    Amplio showroom para ver nuestros productos
                                </p>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <Bus size={32} />
                                </div>
                                <h4 className="feature-title">Accesibilidad</h4>
                                <p className="feature-description">
                                    Fácil acceso en transporte público y privado
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div> */}
            </Container>
        </section>
    );
}

export default Mapa;